import { useEffect, useMemo, useState } from 'react';

import { useGameConfig } from '../../../config/GameConfigProvider';
import { useSettingsSlice } from '../../../store/slices/settings/selectors';
import { useDictionaryService, useDictionaryValue } from '../../dictionary/reactBindings/hooks';
import type { UseAnyDictionaryService, UseAnyDictionaryValue } from '../../dictionary/reactBindings/types';
import type { DictionaryServiceOptions } from '../../dictionary/types';
import { UITranslations } from '../UITranslations';

export const useUITranslationService: UseAnyDictionaryService = (...args) => {
  return useDictionaryService(UITranslations, ...args);
};

export const useUITranslationServiceConnected = (): ReturnType<UseAnyDictionaryService> => {
  const currentLanguage = useSettingsSlice.currentLanguage();
  const {
    config: { translationConfig },
  } = useGameConfig();

  const options: DictionaryServiceOptions = useMemo(() => {
    return {
      keyMap: translationConfig?.uiDictionaryMap,
    };
  }, [translationConfig]);

  return useUITranslationService(currentLanguage, translationConfig.uiFiles ?? [], options);
};

export const useUITranslation: UseAnyDictionaryValue = (...args) => {
  return useDictionaryValue(UITranslations, ...args);
};

/**
 * @deprecated - please use locale from the store instead
 * */
export const useUITranslationLocale = (): string | undefined => {
  const [locale, setLocale] = useState<string | undefined>(UITranslations.locale);

  useEffect(() => {
    const callback = (): void => setLocale(UITranslations.locale);
    UITranslations.addEventListener('locale', callback);
    return (): void => {
      UITranslations.removeEventListener('locale', callback);
    };
  }, []);

  return locale;
};
